import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

const API_URL = process.env.API_URL || 'http://localhost:7890';

const fetchOrganization = async () => {
  const res = await fetch(`${API_URL}/api/v1/organizations/mine`, {
    credentials: 'include',
  });
  if (!res.ok) throw new Error('Failed to fetch organization');
  return res.json();
};

export const useOrganization = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ['organization'],
    queryFn: fetchOrganization,
    staleTime: 1000 * 60 * 10, // 10 minutes
    enabled,
  });
};

export const useSwitchRestaurant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (restaurantId) => {
      const res = await fetch(`${API_URL}/api/v1/organizations/switch-restaurant/${restaurantId}`, {
        method: 'POST',
        credentials: 'include',
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || 'Failed to switch restaurant');
      }
      return res.json();
    },
    onSuccess: () => {
      // Clear all cached data — we're in a new restaurant context
      queryClient.clear();
    },
  });
};
